import { Component, Input, OnInit, inject } from '@angular/core';
import { Message, PrimeNGConfig } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    imports: [MessagesModule],
})
export class MessageComponent implements OnInit {
	private primengConfig = inject(PrimeNGConfig);

	@Input() messages: Message[];


	constructor() {}

	ngOnInit(): void {
		this.primengConfig.ripple = true;
	}
}
